export const classes = {
  menu: 'mt-2 px-2 pt-2 pb-0 w-[24.5rem] overflow-hidden',
  header: 'w-full flex justify-between px-2 mb-3',
  title: 'text-base font-bold text-taupe-3 dark:text-mauve-1',
  buttonsWrapper: 'place-center',
  button:
    'cursor-pointer select-none px-1 text-sm font-semibold text-brand-accent hover:underline dark:text-brand-accent-dark',
  list: 'overflow-y-auto min-h-0 max-h-[350px]',
  emptyMessage: 'text-taupe-2 text-center text-lg py-8 dark:text-mauve-2',
};
